import {
  BookOpenIcon,
  ChatBubbleBottomCenterIcon,
  ClipboardDocumentListIcon,
  CreditCardIcon,
  DevicePhoneMobileIcon,
  PencilSquareIcon,
  PhoneArrowDownLeftIcon,
  PhoneArrowUpRightIcon,
  StarIcon,
} from '@heroicons/react/24/outline';
import { format, isSameDay } from 'date-fns';

import Label from 'components/label';

const ComplaintCall = ({
  call,
  handleClick,
}: {
  call: any;
  handleClick: ({ type, lead }) => void;
}) => {
  let leadIcon = <StarIcon className="w-6 h-6" />;
  const leadTitle =
    // @ts-ignore
    call.__typename === 'lead' && call.metadata && call.metadata.title;

  if (leadTitle && leadTitle === 'Brochure Request') {
    leadIcon = <BookOpenIcon className="w-6 h-6" />;
  }

  if (leadTitle && leadTitle === 'Callback Request') {
    leadIcon = <DevicePhoneMobileIcon className="w-6 h-6" />;
  }

  if (leadTitle && leadTitle === 'Payment Plans Application') {
    leadIcon = <CreditCardIcon className="w-6 h-6" />;
  }

  if (leadTitle && leadTitle === 'Contact Submission') {
    leadIcon = <ClipboardDocumentListIcon className="w-6 h-6" />;
  }

  const title =
    call.user && call.user.name
      ? `${call.user.name} ${call.user.surname}`
      : call.content
        ? `${call.content.name} ${call.content.surname}`
        : call.payload.number;

  const callType =
    call.payload && call.payload.text
      ? call.payload.text
          .split('New')
          .filter(Boolean)
          .map((x) => x.trim())[0]
          .split('call')[0]
          .trim()
      : null;

  const directionLabel =
    call.type === 'outgoing'
      ? 'Outgoing call'
      : call.type === 'incoming'
        ? 'Incoming call'
        : 'Call';

  const phoneNumber =
    call.payload?.from || call.payload?.number || call.payload?.to || null;

  return (
    <button
      type="button"
      className="group mb-3 flex w-full cursor-pointer items-start justify-between rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-left transition-colors duration-100 hover:border-slate-300 hover:bg-white"
      onClick={() => {
        handleClick({ type: call.type, lead: call });
      }}
    >
      <div className="flex min-w-0 items-start gap-4">
        <div className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600">
          {
            // @ts-ignore
            call.type === 'outgoing' && call.__typename === 'call' && (
              <PhoneArrowUpRightIcon className="h-5 w-5 text-emerald-600" />
            )
          }
          {
            // @ts-ignore
            call.type === 'incoming' && call.__typename === 'call' && (
              <PhoneArrowDownLeftIcon className="h-5 w-5 text-amber-600" />
            )
          }
          {call.__typename === 'lead' && leadIcon}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <p className="truncate text-sm font-semibold capitalize text-slate-900">
              {title}
            </p>
            <span className="inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.15em] text-slate-500">
              {callType || directionLabel}
            </span>
          </div>

          <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500">
            {isSameDay(new Date(call.createdAt), new Date()) ? (
              <p>{format(new Date(call.createdAt), "'Today at' HH:mm")}</p>
            ) : (
              <p>{`${format(new Date(call.createdAt), 'dd/MM/yy')} @ ${format(
                new Date(call.createdAt),
                'HH:mm',
              )}`}</p>
            )}
            {phoneNumber ? <p>{phoneNumber}</p> : null}
          </div>

          <div className="mt-3 flex flex-wrap items-center gap-3">
            {call.notes_aggregate && (
              <p className="flex items-center text-xs text-slate-600">
                <PencilSquareIcon className="mr-1 h-4 w-4" />
                <span className="font-medium">
                  {call.notes_aggregate.aggregate.count}
                </span>
              </p>
            )}
            {call.contacts_aggregate && (
              <p className="flex items-center text-xs text-slate-600">
                <ChatBubbleBottomCenterIcon className="mr-1 h-4 w-4" />
                <span className="font-medium">
                  {call.contacts_aggregate.aggregate.count}
                </span>
              </p>
            )}
            {call &&
              call.user &&
              call.user.labels &&
              call.user.labels.length > 0 && (
                <Label x={call.user.labels[0]} classNames={'!mb-0 !mt-0'} />
              )}
          </div>
        </div>
      </div>

      <div className="ml-4 shrink-0 pt-1 text-sm font-medium text-slate-500 transition-colors group-hover:text-slate-900">
        Open
      </div>
    </button>
  );
};

export default ComplaintCall;
